import { render, staticRenderFns } from "./GuangzhouMobileElm02.vue?vue&type=template&id=9849c98e&scoped=true"
import script from "./GuangzhouMobileElm02.vue?vue&type=script&lang=js"
export * from "./GuangzhouMobileElm02.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouMobileElm02.vue?vue&type=style&index=0&id=9849c98e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9849c98e",
  null
  
)

export default component.exports